export default __webpack_public_path__ + "static/media/indefor.f9b6fa9d.png";